import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { THEME } from '../config/copy';
export function RiskChart({ series }) {
    const elementRef = useRef(null);
    useEffect(() => {
        if (!elementRef.current || series.length === 0)
            return;
        const chart = echarts.init(elementRef.current, undefined, { renderer: 'canvas' });
        let peak = 0;
        const drawdown = series.map((point) => {
            peak = Math.max(peak, point.close);
            return peak > 0 ? (point.close / peak - 1) * 100 : 0;
        });
        chart.setOption({
            animationDuration: 350,
            grid: { left: 44, right: 20, top: 34, bottom: 34 },
            tooltip: { trigger: 'axis', valueFormatter: (value) => `${value.toFixed(2)}%` },
            xAxis: {
                type: 'category',
                data: series.map((point) => point.date),
                axisLabel: { color: '#60726B', formatter: (value) => value.slice(0, 7) },
                axisLine: { lineStyle: { color: '#D7E0DB' } }
            },
            yAxis: {
                type: 'value',
                axisLabel: { color: '#60726B', formatter: '{value}%' },
                splitLine: { lineStyle: { color: '#E6ECE9' } }
            },
            series: [
                {
                    name: 'Historical Drawdown',
                    type: 'line',
                    data: drawdown,
                    smooth: true,
                    symbol: 'none',
                    lineStyle: { color: THEME.red, width: 2 },
                    areaStyle: { color: 'rgba(168, 61, 61, 0.14)' }
                }
            ]
        });
        const observer = new ResizeObserver(() => chart.resize());
        observer.observe(elementRef.current);
        return () => {
            observer.disconnect();
            chart.dispose();
        };
    }, [series]);
    return _jsx("div", { ref: elementRef, className: "h-72 w-full", "aria-label": "Historical Drawdown Chart" });
}
